// extracted by mini-css-extract-plugin
module.exports = {"pbWrap":"AcquistiOnlineDetailTemplate_pbWrap__SE6MQ","rotation":"AcquistiOnlineDetailTemplate_rotation__c5Xjh"};